@if (dirty && errors) {
  <div
    class="tw:text-p-red-600 tw:text-[0.75rem] tw:leading-4"
    [class]="errorClasses()"
  >
    {{ errorMsg }}
  </div>
} @else {
  @if (hintContent()) {
    <ng-container *ngTemplateOutlet="hintContent()" />
  } @else {
    @if (hintLabel() || reserveHeight()) {
      @if (showAmountSection()) {
        <div class="tw:flex tw:items-center">
          <div class="complex-hint-label input-hint tw:grow">
            {{ hintLabel() }}
          </div>
          <div class="complex-hint-amount input-hint">
            <span>{{ valueLength || 0 }}</span>
            @if (maxLengthHintValue()) {
              <span>/{{ maxLengthHintValue() }}</span>
            }
          </div>
        </div>
      } @else {
        <div
          [class.input-hint-reserve-height]="reserveHeight()"
          class="input-hint"
        >
          {{ hintLabel() }}
        </div>
      }
    }
  }
}
